export class CoreUrlProvider {
  private static _apiBackendUrl: string = '/api/backend';
  private static _apiOrganisationUrl: string = '/api/organisation';
  static readonly URL = {
    ADMIN: {
      LOGS: `/api/backend/admin-area/event-log`,
      SETTINGS: `/api/backend/admin-area/application-property`,
    },
    AUTH: {
      LOGOUT: `/oidc/connect/logout`,
      USER_ME: `${CoreUrlProvider._apiOrganisationUrl}/user/me`,
      USER_ME_PASSWORD: `${CoreUrlProvider._apiOrganisationUrl}/user/me/password`,
      USER_DETAILS: `${CoreUrlProvider._apiOrganisationUrl}/user/{userUuid}/security-details`,
    },
    SCENARIOS: {
      NETWORK: `${CoreUrlProvider._apiBackendUrl}/scenario/{uuid}/graph`,
      NODE_EDIT: `${CoreUrlProvider._apiBackendUrl}/scenario/{uuid}/node/{nodeUuid}`,
      LIST: `${CoreUrlProvider._apiBackendUrl}/scenario?filter_str_name={name}&sort_{column}={dir}&page={page}&sizeOfPage={size}&filter_str_tags={tags}&filter_str_folderParentUuid={folder}`,
      DELETE: `${CoreUrlProvider._apiBackendUrl}/scenario/{id}`,
      CREATE: `${CoreUrlProvider._apiBackendUrl}/scenario`,
      CREATE_RUN: `${CoreUrlProvider._apiBackendUrl}/scenario/create-run`,
      BASE: `${CoreUrlProvider._apiBackendUrl}/scenario/{id}`,
      RUN: `${CoreUrlProvider._apiBackendUrl}/scenario/run`,
      UPDATE_RUN: `${CoreUrlProvider._apiBackendUrl}/scenario/{uuid}/update-run`,
      SANKEY: `${CoreUrlProvider._apiBackendUrl}/scenario/sankey/{uuid}/{nodeName}/{bucketName}`,
    },
    COMPLEX: {
      LIST: `${CoreUrlProvider._apiBackendUrl}/complex?filter_str_name={name}&sort_{column}={dir}&page={page}&sizeOfPage={size}&filter_str_tags={tags}&filter_str_folderParentUuid={folder}`,
      RUN: `${CoreUrlProvider._apiBackendUrl}/complex/results`,
      RESULT: `${CoreUrlProvider._apiBackendUrl}/complex/{uuid}/results`,
      BASE: `${CoreUrlProvider._apiBackendUrl}/complex/{uuid}`,
      CREATE: `${CoreUrlProvider._apiBackendUrl}/complex`,
      RUN_SAVED: `${CoreUrlProvider._apiBackendUrl}/complex/{uuid}/results`,
    },
    USERS: {
      BASE: `${CoreUrlProvider._apiOrganisationUrl}/user`,
      BASE_UUID: `${CoreUrlProvider._apiOrganisationUrl}/user/{uuid}`,
      UNLOCK: `${CoreUrlProvider._apiOrganisationUrl}/user/{uuid}/unlock`,
    },
    RELEASE_NOTES: {
      SYSTEM: `../assets/release-notes/application-release-notes.json`,
      MODEL: `../assets/release-notes/model-release-notes.json`,
      USER_MANUAL: `../assets/user-manual/HCATUserManual.pdf`,
    },
    CACHE: {
      BASE: `${CoreUrlProvider._apiBackendUrl}/cache/authenticated-user-cache/{uuid}`,
    },
    SSE: {
      BASE: `${CoreUrlProvider._apiBackendUrl}/optimisation/evaluation/result/subscribe`, //TODO: REVIEW
    },
    MODELS: {
      BASE: `${this._apiBackendUrl}/model`,
      BASE_UUID: `${this._apiBackendUrl}/model/{uuid}`,
      SHORT: `${this._apiBackendUrl}/model/short`,
      NETWORK: `${CoreUrlProvider._apiBackendUrl}/model/{uuid}/graph`,
    },
    TAGS: {
      BASE: `${this._apiBackendUrl}/tag`,
    },
    FOLDER_STRUCTURE: {
      BASE: `${CoreUrlProvider._apiBackendUrl}/folder-structure`,
      BASE_UUID: `${CoreUrlProvider._apiBackendUrl}/folder-structure/{uuid}`,
      RENAME: `${CoreUrlProvider._apiBackendUrl}/folder-structure/{uuid}/rename`,
      ROOT: `${CoreUrlProvider._apiBackendUrl}/folder-structure/root`,
      MOVE: `${CoreUrlProvider._apiBackendUrl}/folder-structure/{uuid}/move`,
    },
  };
}
